<!-- eslint-disable max-lines -->
<template>
    <div class="bidding-account-list">
        <div class="bidding-list-btn" v-if="detailData.customerCode">
            <!-- <lotsButton v-has="authorityCode.add" type="primary" icon="el-icon-circle-plus-outline"
                size="mini" title="新增">
                <el-dropdown class="bidding-account-list-dropdown" trigger="hover"
                    :append-to-body="false">
                    <span class="el-dropdown-link">
                        新增<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="bidding-account-list-dropdown-menu">
                        <el-dropdown-item class="dropdown-item"
                            @click.native="handleAddRow('1')">公网投标网站</el-dropdown-item>
                        <el-dropdown-item class="dropdown-item"
                            @click.native="handleAddRow('2')">私网投标网站</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </lotsButton> -->
            <lotsButton  v-has="authorityCode.add" icon="el-icon-circle-plus-outline" type="text" size="medium" title="保存"
                @click="handleAddRow('1')">公网投标网站
            </lotsButton>
            <lotsButton  v-has="authorityCode.add" icon="el-icon-circle-plus-outline" type="text" size="medium" title="保存"
                @click="handleAddRow('2')">私网投标网站
            </lotsButton>
            <lotsButton  v-has="authorityCode.save" icon="el-icon-circle-check" type="text" size="medium" title="保存"
                @click="handleBatchSave">保存
            </lotsButton>
            <lotsButton v-has="authorityCode.export" icon="el-icon-download" type="text" size="medium"
                title="导出" @click="handleExport">导出
            </lotsButton>
        </div>
        <edit-table-box ref="editTableBoxRef" :height="tableHeight"
            v-loading="accountList.tableLoading" :selection="config.selection" :index="config.index"
            :columns="config.columns" :tableData="accountList.totalData" :control="true"
            :actions="config.actions" @btn-event="handleBtnEvent" :allowRowClick="false"
            @selection-change="accountList.handleSelectedRow" @sort-change="handleSort"
            @element-change="handleElementChange">
            <template #col-header="{ item }">
                <col-header-filter v-if="item.filterType" :item="item"
                    :popoverWidth="item.popoverWidth" @filter="handleColFilter" />
                <span v-else-if="['accountPassword', 'websiteAccount', 'registrantPhone'].includes(item.prop)" class="slot-box header-slot-box">
                    <span>{{ item.label }}</span>
                    <img class="text-eyes"
                        :src="getFieldVisible(item.prop) ? iconOpenEyes : iconCloseEyes" alt=""
                        @click.stop="toggleGlobalPassword(item.prop)" />
                </span>
                <span v-else>{{ item.label }}</span>
            </template>
            <template #col-append="{ item, row, rIndex }">
                <span
                    v-if="['customerLevel', 'accountType', 'hasUpdateIn90days','accountStatus'].includes(item.prop)">{{
                        codesToNames(row[item.prop] + '',
                    dictDatas[item.optionsKey]) }}</span>
                <a v-else-if="item.prop === 'websiteUrl' && row.edit === -3" :href="getWebsiteUrl(row[item.prop])"
                    target="_blank" class="website-url-link">{{ row[item.prop] }}</a>
                <span v-else-if="item.prop === 'accountRegistrantName'">{{ row[item.prop] || '--' }}</span>
                <span v-else-if="item.prop === 'accountManagerName'">{{ row[item.prop] || '--' }}</span>
                <span v-else-if="item.prop === 'websiteAccount' && row.edit === -3 && row[item.prop]" class="password-cell">
                    <span class="password-text" :title="getRowPasswordShow(row, 'websiteAccount') ? row[item.prop] : ''">
                        {{ getRowPasswordShow(row, 'websiteAccount') ? row[item.prop] : maskAccount(row[item.prop]) }}
                    </span>
                    <img class="row-eyes" :src="getRowPasswordShow(row, 'websiteAccount') ? iconOpenEyes : iconCloseEyes" alt=""
                        @click.stop="toggleRowPassword(row, 'websiteAccount')" />
                </span>
                <span v-else-if="item.prop === 'accountPassword' && row.edit === -3 && row[item.prop]" class="password-cell">
                    <span class="password-text" :title="getRowPasswordShow(row, 'accountPassword') ? row[item.prop] : ''">
                        {{ getRowPasswordShow(row, 'accountPassword') ? row[item.prop] : '********' }}
                    </span>
                    <img class="row-eyes" :src="getRowPasswordShow(row, 'accountPassword') ? iconOpenEyes : iconCloseEyes" alt=""
                        @click.stop="toggleRowPassword(row, 'accountPassword')" />
                </span>
                <span v-else-if="item.prop === 'registrantPhone' && row.edit === -3 && row[item.prop]" class="password-cell">
                    <span class="password-text" :title="getRowPasswordShow(row, 'registrantPhone') ? row[item.prop] : ''">
                        {{ getRowPasswordShow(row, 'registrantPhone') ? row[item.prop] : desensitization.phone(row[item.prop]) }}
                    </span>
                    <img class="row-eyes" :src="getRowPasswordShow(row, 'registrantPhone') ? iconOpenEyes : iconCloseEyes" alt=""
                        @click.stop="toggleRowPassword(row, 'registrantPhone')" />
                </span>
            </template>
            <template v-slot:edit-col-append="{ item, row, rIndex }">
                <span
                    v-if="['customerLevel', 'accountType', 'hasUpdateIn90days','accountStatus'].includes(item.prop)">{{
                        codesToNames(row[item.prop] + '',
                    dictDatas[item.optionsKey]) }}</span>
                <el-input v-else-if="item.prop === 'websiteUrl'" v-model="row[item.prop]"
                    :maxlength="200" placeholder="请输入投标网址，支持www或https://开头" size="mini" />
                <el-input v-else-if="item.prop === 'remark'" v-model="row[item.prop]"
                    type="textarea" :rows="3" :maxlength="500" show-word-limit placeholder="请输入备注" size="mini" />
            </template>
        </edit-table-box>
        <div class="footer">
            <lots-pagination @size-change="accountList.sizeChange"
                :current-page.sync="accountList.pageNo" @current-change="accountList.pageChange"
                layout="total, sizes, prev, pager, next, jumper" :total="accountList.pageTotal">
            </lots-pagination>
        </div>
    </div>
</template>
<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import editTableBox from '@/components/lots/editTableBox/Index';
import colHeaderFilter from '@/modules/mdm/components/colHeaderFilter/Index';
import {
    getBiddingAccountList, biddingAccountEnableApi, biddingAccountDiscardApi,
    biddingAccountExportApi, biddingAccountBatchSaveApi, getBiddingAccountPermissionApi
} from '@/modules/mdm/api/customer/biddingAccountManage.js';
import { ListClass } from '@/modules/mdm/composition/dc/common/list/ListClass';
import { tableConfig as configStatic } from './config';
import { ref, reactive, onMounted, computed, watch } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import lotsButton from '@/components/lots/lotsButton';
import store from '@/store/index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import _ from 'lodash';

const defaultNotNecessaryProps = [
    'accountRegistrant', 'accountManager', 'remark', 'customerOwnerName',
    'accountRegistrantName', 'accountManagerStatus', 'hasUpdateIn90days',
    'customerManager', 'customerManagerName', 'accountManagerName',
    'isReviewed', 'createTime', 'updateTime', 'passwordUpdateTime',
    'accountManagerUpdateTime', 'customerGroupName', 'accountStatus', 'customerLevel',
    'managerUpdateTime'
];

export default {
    name: 'biddingAccountList',
    components: {
        lotsPagination,
        editTableBox,
        colHeaderFilter,
        lotsButton
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(_.cloneDeep(configStatic));
        const authorityCode = reactive(btnAuthority.biddingAccountManage);
        const TABLECONFIG = computed(() => {
            return config;
        });

        class AccountListClass extends ListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                condition = searchDataFormat(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v, index) => {
                        v.edit = -3;
                        v.allowEdit = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.edit);
                        v.enableLoading = false;
                        v.accountType = v.accountType?.toString();
                        v.isReviewed = v.isReviewed?.toString();
                        v.hasUpdateIn90days = v.hasUpdateIn90days?.toString();
                        v.accountPasswordVisible = false;
                        v.registrantPhoneVisible = false;
                        v.websiteAccountVisible = false;
                        v.backup = _.cloneDeep(v);
                        delete v.backup.backup;
                        if (v.accountType?.toString() === '1') {
                            v.disableProps = ['customerName'];
                            v.notNecessaryProps = [...defaultNotNecessaryProps, 'customerName'];
                        } else {
                            v.notNecessaryProps = defaultNotNecessaryProps;
                        }
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                globalVisibleMap.accountPassword.value = false;
                globalVisibleMap.websiteAccount.value = false;
                globalVisibleMap.registrantPhone.value = false;
                updateColumnDisabled();
            }
        }

        const accountList = new AccountListClass({
            Api: {
                listApi: getBiddingAccountList
            }
        });

        const { userCode, userName } = store.getters.user;
        const handleAddRow = (type) => {
            if (!props.detailData.customerCode) {
                return Message.warning('当前无客户信息,请保存后再新增');
            }
            const newItem = {
                edit: 2,
                sealAdminName: undefined,
                accountType: type,
                allowEdit: true,
                accountRegistrant: userCode,
                accountRegistrantName: userName,
                accountManager: userCode,
                accountManagerName: userName,
                accountPasswordVisible: false,
                registrantPhoneVisible: false,
                websiteAccountVisible: false,
                customerCode: props.detailData.customerCode,
                customerName: props.detailData.customerName,
                customerLevel: props.detailData.calCustomerLevelCode,
                customerOwnerName: props.detailData.customerOwnerName,
                customerOwnerCode: props.detailData.customerOwnerCode,
                customerGroupName: props.detailData.customerGroupName,
                customerGroupCode: props.detailData.customerGroupCode
            };
            newItem.backup = _.cloneDeep(newItem);
            delete newItem.backup.backup;
            accountList.totalData.value.unshift(newItem);
        };

        const handleBtnEvent = (row, event, index) => {
            if (event === 'discard') {
                handleDiscard(row);
            } else if (event === 'enable') {
                handleEnable(row);
            }
        };

        const handleDiscard = (row) => {
            MessageBox.confirm('确定要废弃该数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                biddingAccountDiscardApi({ id: row.id }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('废弃成功');
                        accountList.getList();
                    }
                });
            }).catch(() => { });
        };

        const handleEnable = (row) => {
            row.enableLoading = true;
            biddingAccountEnableApi({ id: row.id }).then(res => {
                row.enableLoading = false;
                if (res && +res.code === 0) {
                    Message.success('重启成功');
                    accountList.getList();
                }
            }).catch(() => {
                row.enableLoading = false;
            });
        };

        const handleElementChange = ({ prop, val, row, index }) => {
            if (prop === 'accountManager') {
                row.accountManagerStatus = undefined;
            }
        };

        const handleSort = ({ prop, order }) => {
            accountList.getList({
                orderBy: prop?.replace(/([A-Z])/g, '_$1').toLowerCase(),
                orderByType: order === 'ascending' ? 'asc' : 'desc'
            });
        };

        const currentFilterObj = ref({});
        const searchDataFormat = (condition = {}, type = 'search') => {
            const numberProps = ['hasUpdateIn90days', 'isReviewed'];
            const dateProps = ['updateTime', 'createTime'];
            let _params;
            if (type === 'colFilter') {
                _params = { ...condition, ..._.cloneDeep(currentFilterObj.value) };
            } else {
                _params = { ..._.cloneDeep(currentFilterObj.value), ...condition };
            }

            Object.keys(_params).forEach(v => {
                !_params[v] && _params[v] !== 0 && (_params[v] = undefined);
            });

            const page = { ..._.pick(_params, ['pageNo', 'pageSize']) };
            const filterCondition = _.omit(_params, ['pageNo', 'pageSize']);

            numberProps.forEach(prop => {
                if (filterCondition[prop] !== undefined && filterCondition[prop] !== null) {
                    filterCondition[prop] = Number(filterCondition[prop]);
                }
            });

            dateProps.forEach(prop => {
                if (filterCondition[prop] && Array.isArray(filterCondition[prop]) && filterCondition[prop].length === 2) {
                    filterCondition[`${prop}From`] = filterCondition[prop][0];
                    filterCondition[`${prop}To`] = filterCondition[prop][1];
                    delete filterCondition[prop];
                }
            });

            let result;
            if (type === 'colFilter') {
                result = { ...condition, ...filterCondition };
            } else {
                result = { ...filterCondition };
            }
            return { ...result, ...page };
        };

        const handleColFilter = ({ prop, value }) => {
            currentFilterObj.value[prop] = value;
            accountList.getList({ ...currentFilterObj.value });
        };

        const maskAccount = (account) => {
            if (!account || account.length <= 4) return account;
            return account.substring(0, 2) + '***' + account.substring(account.length - 2);
        };

        const getWebsiteUrl = (url) => {
            if (!url) return '';
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            return 'https://' + url;
        };

        const globalVisibleMap = {
            accountPassword: ref(false),
            websiteAccount: ref(false),
            registrantPhone: ref(false)
        };
        const getGlobalVisible = (fieldType) => {
            return globalVisibleMap[fieldType]?.value || false;
        };
        const getFieldVisible = (fieldType) => {
            const fieldMap = globalVisibleMap[fieldType];
            return fieldMap && fieldMap.value;
        };
        const setGlobalVisible = (fieldType, value) => {
            if (globalVisibleMap[fieldType]) {
                globalVisibleMap[fieldType].value = value;
            }
        };

        const toggleGlobalPassword = (fieldType) => {
            const current = getGlobalVisible(fieldType);
            setGlobalVisible(fieldType, !current);
            if (!current) {
                accountList.totalData.value.forEach(row => {
                    row[fieldType + 'Visible'] = true;
                    if (row.backup) {
                        row.backup[fieldType + 'Visible'] = true;
                    }
                });
            }
        };
        const getRowPasswordShow = (row, fieldType) => {
            const key = fieldType + 'Visible';
            return getGlobalVisible(fieldType) && row[key];
        };
        const toggleRowPassword = (row, fieldType) => {
            const key = fieldType + 'Visible';
            const globalVisible = getGlobalVisible(fieldType);
            if (!globalVisible) {
                setGlobalVisible(fieldType, true);
                accountList.totalData.value.forEach(rowItem => {
                    rowItem[key] = (rowItem === row);
                    if (rowItem.backup) {
                        rowItem.backup[key] = (rowItem === row);
                    }
                });
            } else {
                row[key] = !row[key];
                if (row.backup) {
                    row.backup[key] = row[key];
                }
            }
        };

        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });

        const handleExport = () => {
            const newData = _.cloneDeep(accountList.searchModel.value);
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns);
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...searchDataFormat(newData),
                excelTitleList,
                customerCode: props.detailData.customerCode
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            biddingAccountExportApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const handleBatchSave = () => {
            const saveData = accountList.totalData.value.filter(v => v.edit === 2);
            if (saveData.length === 0) {
                Message.warning('暂无需要保存的数据');
                return;
            }
            const isValid = setupContext.refs.editTableBoxRef.tableExamine(saveData);
            if (!isValid) {
                return;
            }
            const hasSpaceData = [];
            saveData.forEach((v) => {
                const originalIndex = accountList.totalData.value.findIndex(item => item === v);
                const passwordHasSpace = v.accountPassword && /\s/.test(v.accountPassword);
                const accountHasSpace = v.websiteAccount && /\s/.test(v.websiteAccount);
                if (passwordHasSpace || accountHasSpace) {
                    hasSpaceData.push({
                        ...v,
                        originalIndex: originalIndex + 1,
                        passwordHasSpace,
                        accountHasSpace
                    });
                }
            });
            const invalidCustomerNameData = saveData.filter(v => {
                return v.accountType === '2' && !v.customerName;
            });
            if (invalidCustomerNameData.length > 0) {
                const invalidRows = invalidCustomerNameData.map(v => {
                    const originalIndex = accountList.totalData.value.findIndex(item => item === v);
                    return `第${originalIndex + 1}行：${v.websiteName || '未命名网站'}`;
                }).join('、');
                Message.warning(`私网类型账号的客户名称为必填项，请检查：${invalidRows}`);
                return;
            }
            const formatData = saveData.map(v => {
                const { edit, allowEdit, enableLoading, ...rest } = v;
                return rest;
            });
            const passwordSpaceMsg = hasSpaceData.filter(v => v.passwordHasSpace);
            const accountSpaceMsg = hasSpaceData.filter(v => v.accountHasSpace);
            const confirmMsgParts = [];
            if (accountSpaceMsg.length > 0) {
                confirmMsgParts.push(`以下网站名称的账号存在空格：<br />${accountSpaceMsg.map(v => `第${v.originalIndex}行：${v.websiteName}`).join('<br />')}<br />`);
            }
            if (passwordSpaceMsg.length > 0) {
                confirmMsgParts.push(`以下网站名称的密码存在空格：<br />${passwordSpaceMsg.map(v => `第${v.originalIndex}行：${v.websiteName}`).join('<br />')}<br />`);
            }
            const confirmMsg = confirmMsgParts.length > 0 ? confirmMsgParts.join('') : '';
            MessageBox.confirm(`${confirmMsg}请确认是否保存选中的 ${saveData.length} 条数据？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                biddingAccountBatchSaveApi(formatData).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('保存成功');
                        accountList.getList();
                    }
                });
            }).catch(() => { });
        };

        const permissionData = ref({
            isSystemAdmin: false,
            isTendererManager: false
        });
        const canEditAccount = computed(() => {
            return permissionData.value.isSystemAdmin || permissionData.value.isTendererManager;
        });
        const accountRegistrantDisabled = computed(() => {
            return !canEditAccount.value;
        });
        const accountManagerDisabled = computed(() => {
            return !canEditAccount.value;
        });
        const dictDatas = ref({});
        const updateColumnDisabled = () => {
            const accountRegistrantCol = config.columns.find(col => col.prop === 'accountRegistrant');
            const accountManagerCol = config.columns.find(col => col.prop === 'accountManager');
            if (accountRegistrantCol) {
                accountRegistrantCol.disabled = accountRegistrantDisabled.value;
            }
            if (accountManagerCol) {
                accountManagerCol.disabled = accountManagerDisabled.value;
            }
        };
        watch(() => [permissionData.value.isSystemAdmin, permissionData.value.isTendererManager], () => {
            updateColumnDisabled();
        }, { immediate: true });

        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList(config.columns, ['LCRM_PRIVILEGED_ROLE_LIST']);
            await getBiddingAccountPermissionApi({}).then(res => {
                if (res && +res.code === 0) {
                    permissionData.value = {
                        isSystemAdmin: res.data?.systemAdmin || false,
                        isTendererManager: res.data?.tendererManager || false
                    };
                    updateColumnDisabled();
                }
            });
        });
        watch(
            () => [props.activeName, props.detailData],
            async (newVal, oldVal) => {
                if (newVal[0] === 'biddingAccount' && newVal[1].customerCode) {
                    accountList.getList();
                }
            }
        );
        return {
            accountList,
            config,
            TABLECONFIG,
            authorityCode,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            desensitization: otherUtils.desensitization,
            canEditAccount,
            handleAddRow,
            handleBtnEvent,
            handleElementChange,
            handleSort,
            handleColFilter,
            handleExport,
            handleBatchSave,
            maskAccount,
            getWebsiteUrl,
            iconCloseEyes,
            iconOpenEyes,
            globalVisibleMap,
            getGlobalVisible,
            getFieldVisible,
            toggleGlobalPassword,
            getRowPasswordShow,
            toggleRowPassword
        };
    }
};
</script>
<style lang="less">
.bidding-account-list {
    width: 100%;

    .bidding-list-btn {
        display: flex;
    }

    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .website-url-link {
        color: #409EFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .slot-box {
        display: flex;
        align-items: center;

        .text-eyes {
            width: 14px;
            margin-left: 4px;
            cursor: pointer;
            flex-shrink: 0;
        }

        &.header-slot-box {
            justify-content: space-between;
            cursor: pointer;
            width: 100%;
        }
    }

    .password-cell {
        display: flex;
        align-items: center;
        gap: 4px;

        .password-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .row-eyes {
            width: 14px;
            cursor: pointer;
            flex-shrink: 0;
        }
    }
}

.bidding-account-list-dropdown.el-dropdown {
    color: #fff;
    vertical-align: middle;

    .el-button--mini {
        padding: 7px 15px;
    }
}

.bidding-account-list-dropdown-menu {
    background: #fff;
    padding: 0;
    white-space: nowrap;

    .dropdown-item {
        width: 130px !important;
        color: #333;
        font-size: 14px;
        padding: 8px 20px;
        line-height: 1.5;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        text-align: center;
        justify-content: center;
        display: flex;
        color: #4285f5;
    }

    .dropdown-item:hover {
        background: #f5f7fa;
        color: #4285f5;
    }
}
</style>
